import cx from 'classnames';
import { useEffect, useRef, useState } from 'react';
import { TDropdownContainer } from './dropdown.model';
import styles from './dropdown.module.scss';

const DropdownContainer = (props: TDropdownContainer) => {
  const { className, position, children } = props;

  const [v, h] = position.split('_');
  const ref = useRef<HTMLDivElement>(null);
  const [gap, setGap] = useState<number | null>(null);

  useEffect(() => {
    const parent = ref.current?.closest('.dropdown-ref');
    const bound = parent?.getBoundingClientRect();
    bound && setGap(bound?.height + 16);
  }, []);

  const composed = cx(styles.dropdownContainer, styles[v], styles[h], className);

  return (
    <div ref={ref} className={composed} style={{ transform: `translate( 0, ${gap}px)` }}>
      {children}
    </div>
  );
};
export default DropdownContainer;

DropdownContainer.displayName = 'Dropdown.Container';
